<template>
  <div>
    <v-text-field
      v-model="value"
      :label="label ? $t(label) : labelTranslation"
      :rules="rulesCheck"
      type="tel"
      outlined
    />
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import { internationalDocumentRule, internationalDocumentNonRequiredRule } from '@/util/defaultValidationRules'

export default {
  name: 'HDocumentID',

  props: {
    rules: {
      type: Array,
      required: false,
    },

    defaultValue: {
      type: String,
      required: false,
      default: '',
    },

    country: {
      type: String,
      required: false,
      default: 'BR',
    },

    label: {
      type: String,
      required: false,
    },

    isAppointment: {
      type: Boolean,
      required: false,
      default: false,
    },

    isRentOut: {
      type: Boolean,
      required: false,
      default: false,
    }
  },

  computed: {
    userLanguage() {
      return localStorage.getItem('user_language')
    },

    labelTranslation() {
      if (this.country === 'BR' && this.userLanguage === 'pt-BR') return 'CPF/CNPJ'
      return `Driver's license`
    },

    value: {
      get() {
        return this.defaultValue
      },
      set(value) {
        this.handleInput(value)
      },
    },

    rulesCheck() {
      if (!this.rules) return []
      if (this.country === 'BR') return this.rules
      return this.isRentOut ? internationalDocumentRule : internationalDocumentNonRequiredRule
    }
  },

  methods: {
    ...mapMutations(['setAppointmentFields']),

    handleInput(value) {
      this.$emit('input', value)
      if (this.isAppointment) this.setAppointmentFields({ visitor_document: value?.replace(/[^\d]/g, '') })
    },
  },
}
</script>
